<template>
<div class="chapter">
<div class="inner_page">
<p class="C137"><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="C140"><a id="page_vii"></a><a href="#/xhtml/06_Prologue#page_1">Prologue</a></p>
<p class="C140"><a href="#/xhtml/07_The_World_of_Animation_and_the_A#page_7">The World of Animation and the Animation of the World</a></p>
<p class="C140"><em><a href="#/xhtml/08_The_LEGO_Movie_as_Savvy_Cinema#page_17">The LEGO Movie</a></em> <a href="#/xhtml/08_The_LEGO_Movie_as_Savvy_Cinema#page_17">as Savvy Cinema</a></p>
<p class="C140"><span href="#/xhtml/09_Through_the_Rabbit_Hole__into_th#page_32" title="Link target outside of Sample">Through the Rabbit Hole, into the LEGO-Verse</span></p>
<p class="C140"><span href="#/xhtml/10_Falling_into_Narrative#page_45" title="Link target outside of Sample">Falling into Narrative</span></p>
<p class="C140"><span href="#/xhtml/11_The_Extraordinary_Ordinariness_o#page_56" title="Link target outside of Sample">The Extraordinary Ordinariness of LEGO</span></p>
<p class="C140"><span href="#/xhtml/12_The_Secret_Life_of_Toys#page_76" title="Link target outside of Sample">The Secret Life of Toys</span></p>
<p class="C140"><span href="#/xhtml/13_Production_History__Part_1__Proj#page_98" title="Link target outside of Sample">Production History, Part 1: <em>Project Development as LEGO Goes to the Movies</em></span></p>
<p class="C140"><span href="#/xhtml/14_Production_History__Part_2__The#page_117" title="Link target outside of Sample">Production History, Part 2: <em>The Animation Process</em></span></p>
<p class="C140"><span href="#/xhtml/15_Production_History__Part_3__The#page_134" title="Link target outside of Sample">Production History, Part 3: <em>The Screenwriter-Directors</em></span></p>
<p class="C140"><span href="#/xhtml/16_Reception_and_After_Life#page_159" title="Link target outside of Sample">Reception and After-Life</span></p>
<p class="C141"><span href="#/xhtml/17_Coda#page_171" title="Link target outside of Sample">Coda</span></p>
<p class="C140"><em><span href="#/xhtml/18_Acknowledgments#page_173" title="Link target outside of Sample">Acknowledgments</span></em></p>
<p class="C140"><em><span href="#/xhtml/19_Notes#page_176" title="Link target outside of Sample">Notes</span></em></p>
<p class="C140"><em><span href="#/xhtml/20_LEGO_Bibliography#page_199" title="Link target outside of Sample">LEGO Bibliography</span></em></p>
<p class="C140"><em><span href="#/xhtml/21_Index#page_201" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?69dcb412